import ACTIONS from '../../store/actions';
import defaultManifest from './defaultManifest';
export default (function (_ref) {
  var microservice = _ref.microservice;
  return function (dispatch) {
    if (!microservice) {
      dispatch({
        type: ACTIONS.MANIFEST_SET,
        payload: defaultManifest
      });
    } else {
      return dispatch({
        type: ACTIONS.MANIFEST_GET,
        request: {
          url: '/backend/manifest'
        }
      }).then(function (_ref2) {
        var body = _ref2.body;
        return dispatch({
          type: ACTIONS.MANIFEST_GET_RESOLVED,
          payload: body
        });
      }).catch(function () {
        return dispatch({
          type: ACTIONS.MANIFEST_SET,
          payload: defaultManifest
        });
      });
    }
  };
});